import React from "react";
import { SectionHeading, TwoColumnsInput } from "global";
import {
  AeroplanContainer,
  AeroplanText,
  AeroplanLogo,
  AeroplanHeadingContainer,
} from "./aeroplan.styles";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import {
  updateLoyaltyCardNumber,
  updateLoyaltyCardNumberRepeat,
} from "redux/form/form.reducer";
import {
  selectFormErrors,
  selectLoyaltyCardNumber,
  selectLoyaltyCardNumberRepeat,
} from "redux/form/form.selector";
import Input from "components/input/input.component";

const Aeroplan: React.FC = () => {
  const formErrors = useAppSelector(selectFormErrors);
  const loyaltyCardNumber = useAppSelector(selectLoyaltyCardNumber);
  const loyaltyCardNumberRepeat = useAppSelector(selectLoyaltyCardNumberRepeat);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleAeroplanInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.currentTarget;
    if (value.length > 9) return;

    // Testing just to be a number
    const regex = /^\d*$/g;
    if (regex.test(value)) {
      if (name === "loyaltyPointsRepeat") {
        dispatch(updateLoyaltyCardNumberRepeat(value));
      } else {
        dispatch(updateLoyaltyCardNumber(value));
      }
    }
  };

  return (
    <AeroplanContainer aria-live="polite">
      <AeroplanHeadingContainer>
        <SectionHeading style={{ marginBottom: 0 }}>
          {t("Are you aeroplan")}
        </SectionHeading>
        <AeroplanLogo
          src={process.env.REACT_APP_AEROPLAN_LOGO}
          alt="Aeroplan Logo"
        />
      </AeroplanHeadingContainer>

      <AeroplanText>{t("Get points")}</AeroplanText>

      <TwoColumnsInput style={{ width: "100%" }} isMobileFullWidth>
        <Input
          label="Aeroplan number"
          type="text"
          name="loyaltyPoints"
          id="loyaltyPoints"
          onChange={handleAeroplanInput}
          value={loyaltyCardNumber}
          isError={formErrors.loyaltyCardNumber}
          placeholder={t("9-digit number")}
        />
        <Input
          label="Confirm aeroplan number"
          type="text"
          name="loyaltyPointsRepeat"
          id="loyaltyPointsRepeat"
          onChange={handleAeroplanInput}
          value={loyaltyCardNumberRepeat}
          isError={formErrors.loyaltyCardNumberRepeat}
          placeholder={t("9-digit number")}
          disabled={!loyaltyCardNumber}
        />
      </TwoColumnsInput>
    </AeroplanContainer>
  );
};

export default Aeroplan;
